const ACFBlockProductHotspots = (domEl) => {

	// Init each hotspot area
	domEl.querySelectorAll('.hotspot-area').forEach(hotspotArea => new ACFBlockProductHotspotsArea(hotspotArea));

	// Init the pill btns
	const handleClick = (e) => {
		e.preventDefault();

		const index = parseInt(e.currentTarget.dataset.index);

		domEl.setAttribute('data-active-area', index);
		domEl.querySelectorAll('.pill-btn').forEach(btn => {
			if(parseInt(btn.dataset.index) === index) {
				btn.classList.add('js-active');
			}
			else {
				btn.classList.remove('js-active');
			}
		});

	};
	domEl.querySelectorAll('.pill-btn').forEach(btn => btn.addEventListener('click', handleClick));
};

export default ACFBlockProductHotspots;


const ACFBlockProductHotspotsArea = (domEl) => {

	const hotspotBtns = domEl.querySelectorAll('.hotspot-btn');
	const hotspotDescriptions = domEl.querySelectorAll('.descriptions .hotspot');
	let activeIndex = 1;

	const render = () => {

		hotspotBtns.forEach(btn => {
			if(parseInt(btn.dataset.index) === activeIndex) {
				btn.classList.add('js-active');
			}
			else {
				btn.classList.remove('js-active');
			}
		});

		// Hide the selected and reveal the description matching the index
		hotspotDescriptions.forEach(hotspot => {
			if(parseInt(hotspot.dataset.index) === activeIndex) {
				hotspot.classList.add('js-active');
			}
			else {
				hotspot.classList.remove('js-active');
			}
		});

	}

	const handleClick = (e) => {
		e.preventDefault();

		activeIndex = parseInt(e.currentTarget.dataset.index);
		render();
	};

	hotspotBtns.forEach(btn => btn.addEventListener('click', handleClick));
	render();

};